<template>
  <v-container @mouseup="stopDrag($event)"
    class="container--fluid"
    fluid
  >
    <div v-if="module && module.fields">
      <v-btn
        v-if="mobileBreakpoint && hasCreateAccess && !id && level === 0"
        :dark="!subtableFormOpenForModule"
        @click="openNewForm"
        fixed
        bottom
        right
        top
        color="green lighten-1"
        fab
        :style="floatingAddButtonStyle"
        :x-small="appBarIsDense"
        :small="!appBarIsDense"
      >
        <v-icon small>fa-plus</v-icon>
      </v-btn>
      <v-row
        :no-gutters="mobileBreakpoint || level > 0 || cs.noDesktopGutters"
      >
        <v-col
          :cols="listCols"
          :class="(id && !showListNextToForm ? 'd-none' : hideList ? 'hidden-md-and-down' : '') + ' '"
          :style="!mobileBreakpoint && cs.noDesktopGutters ? 'border-right: 3px solid #ccc;' : ''"
        >
          <v-app-bar
            v-if="!$vuetify.breakpoint.smAndDown || level > 0"
            class="list-app-bar elevation-1"
            :height="appBarIsDense ? 40 : 60"
            :color="'rgba(245, 245, 245)'"
            :style="!showSearchBar ? 'border-bottom: 1px solid #bbb;' : ''"
          >
            <!-- v-btn
              @click="openList"
              icon
              :small="appBarIsDense"
              color="orange lighten-1"
            >
              <v-icon
                small
              >
                fa-search
              </v-icon>
            </v-btn -->
              <v-btn
                @click="toggleSearchClose"
                icon
                :small_x="appBarIsDense"
                color="grey lighten-1"
              >
                <v-icon
                  small
                >
                  fa-search
                </v-icon>
              </v-btn>
            <v-toolbar-title
              :class="'list-title ' + (appBarIsDense ? ' list-title-dense' : '')"
              style="padding-left: 0;"
            >
              {{ moduleNameComputed }}
            </v-toolbar-title>
            <v-spacer />

            <div
              :style="!mobileBreakpoint ? 'padding-left: 20px;'  : ''"
            >
              <template v-if="module.moduleViews">
                <v-btn
                  v-for="(moduleView, mvindex) in moduleViewsComputed"
                  :key="mvindex"
                  fab
                  :icon="!selectedModuleViewsIds.includes(moduleView.id)"
                  :dark="selectedModuleViewsIds.includes(moduleView.id)"
                  small
                  :small_x="appBarIsDense"
                  :color="moduleView.colorForIcon || 'grey lighten-1'"
                  @click="selectModuleView(moduleView)"
                  class="elevation-0"
                >
                <v-icon
                  small
                >
                  {{ moduleView.icon }}
                </v-icon>
              </v-btn>
              </template>

              <v-btn
                v-if="hasCreateAccess && (!mobileBreakpoint || level > 0)"
                @click="openNewForm"
                color="green lighten-1"
                fab
                dark
                :x-small="appBarIsDense"
                :small="!appBarIsDense"
                class="elevation-0 ml-3"
              >
                <v-icon small>fa-plus</v-icon>
              </v-btn>
              <!-- v-menu
                left
                bottom
              >
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" style="margin-right: -10px;">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item
                    v-if="hasDeleteAccess && !deleteStarted && id !== '0'"
                    @click="startDeleteItem"
                  >
                    <v-list-item-title>
                      Delete <v-icon small>fa-trash</v-icon>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu -->

              <!-- v-btn
                v-if="hasDeleteAccess && !deleteStarted && id !== '0'"
                @click="startDeleteItem"
                :disabled="!!subtableFormOpenForModule"
                icon
                color="warning"
              >
                <v-icon small>fa-trash</v-icon>
              </v-btn>
              <v-btn
                v-else-if="hasDeleteAccess && id !== '0'"
                :disabled="!!subtableFormOpenForModule"
                @click="deleteItem" icon color="error"
                style="margin-right: 70px;"
              >
                <v-icon small>fa-trash</v-icon>
              </v-btn -->
            </div>
          </v-app-bar>
          <v-row
            v-if="$store.getters.objectStatesByModule && $store.getters.objectStatesByModule[module.moduleName]"
            no-gutters
          >
            <v-col cols="12" class="pt-2">
              <module-list-states-filter
                :module="module"
                :show-form-next-to-list="showFormNextToList"
                :open-list="openList"
              />
            </v-col>
          </v-row>

          <v-row no-gutters v-if="showSearchBar">
            <v-col
              cols="12"
              class="elevation-1"
              style=""
            >
              <div style="width: 100%;">
                <div
                  class="pt-5 pb-3"
                  style="float: left; width: 65px;"
                >
                  <v-btn
                    @click="openList"
                    fab
                    dark
                    :small_x="appBarIsDense"
                    color="orange lighten-1"
                    class="elevation-0 mx-3"
                    style="margin-top: -5px !important;"
                    small
                  >
                    <v-icon
                      small
                    >
                      fa-search
                    </v-icon>
                  </v-btn>
                </div>
                <div
                  style="float: left; width: calc(100% - 65px)"
                >
                  <v-row row dense>
                    <template v-for="(field, fieldName) in module.fields">
                      <template v-if="field.listFilter">

                        <v-col
                          v-if="field.filterType === 'SelectSearch'"
                          :key="fieldName"
                          px-2
                        >
                          <v-autocomplete
                            v-model="searchFilters[moduleName + '_' + fieldName]"
                            :items="selectItems[fieldName]"
                            :label="labelText(field)"
                            :item-text="selectItemsDisplayFields[fieldName]"
                            item-value="_id"
                            hide-details
                            clearable
                            @change="openList"
                          />
                        </v-col>

                        <v-col
                          v-else-if="field.filterType === 'Select'"
                          :key="fieldName"
                          px-2
                        >
                          <v-select
                            v-model="searchFilters[moduleName + '_' + fieldName]"
                            :items="selectItems[fieldName]"
                            :label="labelText(field)"
                            :item-text="selectItemsDisplayFields[fieldName]"
                            item-value="_id"
                            hide-details
                            clearable
                            @change="openList"
                          />
                        </v-col>
                        <v-col
                          v-else="field.filterType === 'Text'"
                          :key="fieldName"
                          px-2
                        >
                          <v-text-field
                            v-model="searchFilters[moduleName + '_' + fieldName]"
                            :label="labelText(field)"
                            @keyup.enter="openList"
                            hide-details
                          />
                        </v-col>

                      </template>
                    </template>
                  </v-row>
                </div>
              </div>
            </v-col>
          </v-row>
          <v-data-table
            :headers="headers"
            :items="items"
            :dense="!!cs.denseTable"
            :calculate-widths="true"
            :server-items-length="moduleListItemsCount[moduleName]"
            :loading="loading"
            :options.sync="options"
            :height="tableHeight"
            :footer-props="{
              showFirstLastPage: true,
              itemsPerPageOptions: [10, 25, 50, 100, 200, 500, 1000]
            }"
            :mobile-breakpoint="10"
            class="elevation-1"
            style="position: relative;"
            fixed-header
            id="list-table"
          >
            <template slot="item" slot-scope="props">
              <tr v-if="draggingIndex > props.index && draggingId && dragPlaceholderId === props.item._id"
                :style="dragPlaceholderStyle(props)"
              >
                <td :colspan="fields.length">&nbsp;</td>
              </tr>
              <tr v-if="draggingIndex === props.index"
                :style="dragPlaceholderStyle(props)"
                @mouseenter="changePlaceholderId(props.item)"
              >
                <td :colspan="fields.length">FROM HERE...</td>
              </tr>
              <tr @click="openEditForm(props.item)"
                :style="dragRowStyle(props, props.item.state && props.item.state.stateName &&
                  stateCompletePercentages &&
                  stateCompletePercentages[props.item.state.stateName] &&
                  stateCompletePercentages[props.item.state.stateName])"
                :id="'list-id-' + props.item._id"
                @mouseenter="changePlaceholderId(props.item)"
              >
                <template
                  v-for="(field, fieldName) in sortedFields"
                >
                  <td
                    v-if="showInList(field, fieldName) && fieldName === 'state' && field.type === 'Link'"
                    :key="fieldName"
                    class="text-left"
                  >
                    <template v-if="props.item && props.item[fieldName]">
                      <v-icon
                        small
                        class="pr-3"
                        :color="props.item[fieldName].color"
                      >
                        {{ props.item[fieldName].icon }}
                      </v-icon>
                      {{
                        props.item[fieldName]['stateNameText_' + language] ||
                        props.item[fieldName]['stateNameText_en']
                      }}
                    </template>
                  </td>
                  <td
                    v-else-if="showInList(field, fieldName) && field.type === 'Link'"
                    :key="fieldName"
                    class="text-left"
                  >
                    <template v-if="props.item && props.item[fieldName]">
                      {{
                        props.item[fieldName][field.linkModuleDisplayField] ||
                        props.item[fieldName][field.linkModuleDisplayField + '_' + language] ||
                        props.item[fieldName][field.linkModuleDisplayField + '_en']
                      }}
                    </template>
                  </td>
                  <td
                    v-else-if="showInList(field, fieldName) && field.type === 'MultiLink'"
                    :key="fieldName"
                    class="text-left"
                  >
                    <template v-if="props.item && props.item[fieldName]">
                      <template v-for="(multiLink, ml_index) in props.item[fieldName]">
                        {{
                          multiLink[field.linkModuleDisplayField]
                            ? multiLink[field.linkModuleDisplayField]
                            : ( multiLink[field.linkModuleDisplayField + '_' + language] || multiLink[field.linkModuleDisplayField + '_en']) }}
                      </template>
                    </template>
                  </td>
                  <td
                    v-else-if="showInList(field, fieldName) && field.type === 'Image'"
                    :key="fieldName"
                    class="text-left"
                  >
                    <img
                      v-if="props.item[fieldName]"
                      :src="props.item[fieldName]"
                      width="100"
                    />
                  </td>
                  <td
                    v-else-if="showInList(field, fieldName) && field.type === 'Boolean' &&
                      field.listEdit === true"
                    :key="fieldName"
                    class="text-left"
                    @click.stop="noAction()"
                  >
                    <v-btn
                      :color="props.item[fieldName]
                        ? field.listTrueColor || 'success'
                        : field.listFalseColor || 'error'"
                      class="text-capitalize"
                      :dark="!!(props.item[fieldName] || field.listForceDarkBtn)"
                      :icon="!!(field.listIconOnly)"
                      @click.stop="toggleBooleanValue(props.index + listOffset, fieldName)"
                    >
                      <v-icon small v-if="field.listIcon"
                        :style="field.listIconOnly ? '' : 'padding-right:10px;'"
                      >
                        {{ !props.item[fieldName] && field.listIconForFalse
                            ? field.listIconForFalse
                            : field.listIcon }}
                      </v-icon>
                      {{ field.listIconOnly ? '' : translation(fieldName) }}
                    </v-btn>
                  </td>
                  <td
                    v-else-if="showInList(field, fieldName) && field.type === 'Date'"
                    :key="fieldName"
                    class="text-left"
                  >
                    <b>{{ props.item && props.item[fieldName] ? showDate(props.item[fieldName]) : '' }}</b>
                  </td>
                  <td
                    v-else-if="showInList(field, fieldName) && field.type === 'Datetime'"
                    :key="fieldName"
                    class="text-left"
                  >
                    {{ props.item && props.item[fieldName]
                      ? showDatetimeOrTimeAgo(props.item[fieldName], field.timeagoForDateDays)
                      : '' }}
                  </td>
                  <td
                    v-else-if="showInList(field, fieldName)"
                    :key="fieldName"
                    :class="(field.type === 'Number' ? 'text-right' : 'text-left string-table-column') +
                    (field.fieldName === firstTextFieldName ? ' first-text-field' : '')"
                  >
                    <list-sort-field
                      v-model="props"
                      v-if="fieldName === 'sortOrder'"
                      :index="props.index + 1 + listOffset"
                    />
                    <template v-else>
                      {{
                        field.multilingual
                          ? props.item[fieldName + '_' + language] || props.item[fieldName + '_en']
                          : ''
                      }}
                      <template v-if="fieldName.toLowerCase().includes('icon')">
                        <v-icon
                          :color="props.item.color || ''"
                        >
                          {{ props.item && props.item[fieldName]
                            ? props.item[fieldName]
                            : '' }}
                        </v-icon>
                      </template>
                      <template v-else>
                        {{ props.item && props.item[fieldName]
                          ? props.item[fieldName]
                          : '' }}
                      </template>
                    </template>
                  </td>
                </template>
                <td
                  v-if="pdfTemplates.length > 0"
                  class="text-left"
                  @click.stop=""
                >
                <v-menu bottom offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="primary"
                      dark
                      v-on="on"
                      icon
                    >
                      <v-icon>fa-file-pdf</v-icon>
                    </v-btn>
                  </template>

                  <v-list>
                    <v-list-item
                      v-for="(pdfTemplate, index) in pdfTemplates"
                      :key="index"
                      @click.stop="getPdf(pdfTemplate, props.item, this.lang)"
                      class="text-right"
                    >
                      <v-list-item-title>
                        {{ pdfTemplate.name }}
                        <v-btn
                          v-for="(lang, li) in contentLanguages"
                          :key="li"
                          fab
                          x-small
                          :text="!(props.item && (props.item.lang === lang.code || props.item.language === lang.code))"
                          :outlined="props.item && (props.item.lang === lang.code || props.item.language === lang.code)"
                          class="ml-2 elevation-0"
                          @click.stop="getPdf(pdfTemplate, props.item, lang.code)"
                        >
                          {{ lang.code }}
                        </v-btn>
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                </td>
              </tr>
              <tr v-if="draggingIndex < props.index && draggingId && dragPlaceholderId === props.item._id"
                :style="dragPlaceholderStyle(props)"
              >
                <td :colspan="fields.length">&nbsp;</td>
              </tr>
            </template>
          </v-data-table>
        </v-col>
        <v-col
          v-if="showFormNextToList"
          :cols="$vuetify.breakpoint.lgAndUp && showListNextToForm ? 8 : 12"
          :class="'py-0 ' + (mobileBreakpoint ? 'px-0' : '')"
          :style="!$vuetify.breakpoint.mdAndDown && cs.noDesktopGutters ? 'border-left: 2px solid #ddd;' : ''"
        >
          <module-form
            :id="id"
            :module-name="moduleName"
            :level="level"
            :callback-on-change="itemSaveCallback"
          />
        </v-col>
        <v-col
          v-else-if="showRightModuleView"
          :cols="mobileBreakpoint ? 12 : 3"
          :class="'py-0 ' + (mobileBreakpoint ? 'px-0' : '')"
          :style="!$vuetify.breakpoint.mdAndDown && cs.noDesktopGutters ? 'border-left: 2px solid #ddd;' : ''"
        >
          <div
            v-if="mobileBreakpoint"
            class="text-left px-5 mb-3"
            style="cursor: pointer;"
            @click="selectedRightModuleView = null"
          >
            <v-icon small class="mr-2">fa-arrow-left</v-icon>
            {{ moduleNameComputed }}
          </div>
          <CalendarMonthsPreview
            :items="items"
            :fields="fields"
            :top-offset="parentLevelsTopOffset"
          />
        </v-col>
        <v-col
          v-if="showBottomModuleView"
          :cols="12"
          :class="'py-0 ' + (mobileBreakpoint ? 'px-0' : '')"
          :style="!$vuetify.breakpoint.mdAndDown && cs.noDesktopGutters ? 'border-left: 2px solid #ddd;' : ''"
        >
          <div
            v-if="mobileBreakpoint"
            class="text-left px-5 mb-3"
            style="cursor: pointer;"
            @click="selectedBottomModuleView = null"
          >
            <v-icon small class="mr-2">fa-arrow-left</v-icon>
            {{ moduleNameComputed }}
          </div>
          <Sparkline
            :items="items"
            :fields="fields"
            :top-offset="parentLevelsTopOffset"
            :module-view="selectedBottomModuleView"
            :search-filters="searchFilters"
            :module-name="moduleName"
            :height="bottomModuleHeight"
          />
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import sharedMethods from './../methods'
import api from './../../api'
import ListSortField from './ListSortField'
import ModuleListStatesFilter from './ModuleListStatesFilter'
import CalendarMonthsPreview from './moduleViews/CalendarMonthsPreview'
import Sparkline from './moduleViews/Sparkline'
import ChartView from './moduleViews/ChartView'
import { createHelpers } from 'vuex-map-fields'
import ModuleForm from './ModuleForm'

import hexRgb from 'hex-rgb'

const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  name: 'ModuleList',

  components: {
    ListSortField,
    ModuleForm,
    ModuleListStatesFilter,
    CalendarMonthsPreview,
    Sparkline,
    ChartView
  },

  data () {
    return {
      module: {},
      totalDesserts: 0,
      desserts: [],
      loading: true,
      options: {
        page: 1,
        itemsPerPage: 100,
        sortBy: ['createdAt'],
        sortDesc: [true],
        mustSort: true,
      },
      searchClosedMobile: true,
      searchClosedDesktop: false, // Changed false for CSR
      selectedRightModuleView: null,
      selectedBottomModuleView: null,
      selectedLeftModuleView: null
    }
  },

  props: {
    moduleName: {
      type: String,
      default: null
    },

    parentModule: {
      type: String,
      default: null
    },

    parentId: {
      type: String,
      default: null
    },

    id: {
      type: String,
      default: null
    },

    setSubtableFormOpenModule: {
      type: Function,
      default: () => {}
    },

    level: {
      type: Number,
      default: 0
    }
  },

  computed: {
    ...mapFields(['draggedX', 'draggedY', 'draggingId', 'searchFilters', 'selectItems',
      'selectItemsDisplayFields', 'dragElOrigY', 'dragElOrigX', 'dragOrigWidth', 'dragOrigHeight',
      'dragPlaceholderId', 'dragStartX', 'dragStartY', 'draggingIndex', 'modules',
      'apiBaseUrl', 'tenant', 'innerHeight', 'innerWidth', 'subtableFormOpenForModule',
      'cs', 'selectedModuleName', 'searchClosedMobileMainList', 'contentLanguages'
    ]),

    bottomModuleHeight () {
      return 300
    },

    moduleNameComputed () {
      return this.module['namePlural_' + this.language] || this.module.namePlural_en || this.module.moduleName
    },

    selectedModuleViews () {
      if (!this.module.moduleViews) { return [] }
      return this.module.moduleViews.filter(moduleView => {
        return (this.selectedBottomModuleView && moduleView.id === this.selectedBottomModuleView.id) ||
        (this.selectedRightModuleView && moduleView.id === this.selectedRightModuleView.id) ||
        (this.selectedLeftModuleView && moduleView.id === this.selectedLeftModuleView.id)
      })
    },

    selectedModuleViewsIds () {
      return this.selectedModuleViews.map(moduleView => moduleView.id)
    },

    moduleViewsComputed () {
      if (!this.module || !this.module.moduleViews) { return [] }
      return this.module.moduleViews.filter(moduleView => (moduleView.onlyLevelZero && this.level === 0) ||
        (moduleView.onlyLevelsOnePlus && this.level > 0) ||
        (!moduleView.onlyLevelZero && !moduleView.onlyLevelsOnePlus))
    },

    selectedRightModuleViewId () {
      return (this.selectedRightModuleView && this.selectedRightModuleView.id) || null
    },

    selectedBottomModuleViewId () {
      return (this.selectedBottomModuleView && this.selectedBottomModuleView.id) || null
    },

    selectedLeftModuleViewId () {
      return (this.selectedLeftModuleView && this.selectedLeftModuleView.id) || null
    },

    showListNextToForm () {
      const user = this.$store.state.user
      // TODO - setting in the future for the user or user group?
      return user.userGroup && user.userGroup.identifier === 'sysadmin'
    },

    hideList () {
      const showingMobuleViewOnMobile = (this.showRightModuleView || this.showBottomModuleView || this.showLeftModuleView) && this.mobileBreakpoint
      return this.showFormNextToList || showingMobuleViewOnMobile
    },

    listCols () {
      if (this.showFormNextToList) {
        return 4
      }
      if (this.showRightModuleView) {
        return 9
      }
      return 12
    },

    showRightModuleView () {
      return !!(this.selectedRightModuleView)
    },

    showBottomModuleView () {
      return !!(this.selectedBottomModuleView)
    },

    showLeftModuleView () {
      return !!(this.selectedLeftModuleView)
    },

    mobileBreakpoint () {
      return this.$vuetify.breakpoint.smAndDown
    },

    showSearchBar () {
      if (this.level === 0 && this.mobileBreakpoint) {
        return !this.searchClosedMobileMainList
      } else if (this.mobileBreakpoint) {
        // On mobile
        return !this.searchClosedMobile
      } else {
        // On desktop
        return !this.searchClosedDesktop
      }
      // if (this.level === 0 && this.mobileBreakpoint) {
      //   return this.searchClosedMobileMainList
      // } else if ((this.mobileBreakpoint || this.showFormNextToList) && !this.searchClosedMobile) {
      //   return true
      // } else if (!this.mobileBreakpoint && !this.showFormNextToList && this.searchClosedDesktop) {
      //   return true
      // }
      // return false
    },

    floatingAddButtonStyle () {
      return {
        top: (this.innerHeight - 60) + 'px'
      }
    },

    appBarIsDense () {
      return this.level > 0
    },

    parentLevelsTopOffset () {
      let offset = 0
      // Deduct level related...
      if (this.level > 0) {
        offset += this.$store.getters.formAppBarHeight
      }
      if (this.level > 0) {
        offset += ((this.level - 1) * this.$store.getters.formAppBarHeightDense)
      }
      // If parent module has tabs
      if (this.parentModule && this.modules[this.parentModule] && this.modules[this.parentModule].tabs && Object.keys(this.modules[this.parentModule].tabs).length > 0) {
        offset += 48
      }

      return offset
    },

    tableHeight () {
      // if (this.level > 0) { return null }
      let height = this.innerHeight - 300
      if (this.cs.noDesktopGutters) {
        height += 36
      }
      if (!this.showSearchBar) {
        height += 67
      }
      if (this.$vuetify.breakpoint.smAndDown) {
        height += 70
      }
      if (this.showBottomModuleView) {
        console.log('height', height)
        height -= this.bottomModuleHeight
      }
      console.log(height)
      // Parent levels top offset
      height -= this.parentLevelsTopOffset
      console.log('height', height)

      return height > 200
        ? height + 'px'
        : 200 + 'px'
    },

    apiUrl () {
      return this.apiBaseUrl + this.tenant
    },

    sortedFields () {
      let fields = []
      let sortedFields = {}
      Object.keys(this.module.fields).forEach(fieldName => {
        fields.push(this.module.fields[fieldName])
      })
      fields.sort((a, b) => parseInt(a.sortOrder) < parseInt(b.sortOrder) ? -1 : 1)
      fields.forEach(field => {
        sortedFields[field.fieldName] = field
      })
      return sortedFields
    },

    firstTextFieldName () {
      let stringFields = Object.keys(this.sortedFields)
        .map(fieldName => this.sortedFields[fieldName])
        .filter(field => field.type === 'String')
      if (stringFields && stringFields[0]) {
        return stringFields[0].fieldName
      }
      return ''
    },

    hasCreateAccess () {
      return this.$store.getters.ac.can('current').createAny(this.moduleName).granted
    },

    showFormNextToList () {
      return this.id && !this.parentModule
    },

    listOffset () {
      return (this.page * this.itemsPerPage) - this.itemsPerPage
    },

    fields () {
      return Object.keys(this.sortedFields)
        .filter(fieldName => {
          return this.showInList(this.sortedFields[fieldName], fieldName)
        })
    },

    isLanguageField () {
      let tmp = Object.keys(this.sortedFields)
        .filter(fieldName => fieldName === 'language')
      return tmp && tmp.length > 0
    },

    items () {
      return this.$store.getters['moduleListItems'][this.moduleName]
    },

    translations () {
      return this.$store.getters['translations']
    },

    moduleListItemsCount () {
      return this.$store.getters['moduleListItemsCount']
    },

    language () {
      return this.$store.getters['language']
    },

    pdfTemplates () {
      return this.$store.getters.pdfTemplatesByModule && this.$store.getters.pdfTemplatesByModule[this.moduleName] || []
    },

    readAttributes () {
      return this.$store.getters.ac.can('current').readAny(this.moduleName).attributes
    },

    listFields () {
      let listFields = []
      if (this.fields) {
        this.fields.forEach(fieldName => {
          const canRead = this.readAttributes.includes(fieldName) ||
            (this.readAttributes.includes('*') && !this.readAttributes.includes('!' + fieldName))
          if (canRead) {
            listFields.push(fieldName)
          }
        })
      }
      return listFields
    },

    headers () {
      let headers = []
      this.fields.forEach(fieldName => {
        headers.push({
          text: this.labelText(this.module.fields[fieldName]),
          align: 'left',
          sortable: (this.module.fields[fieldName].sortable ? 'true' : false),
          value: fieldName
        })
      })
      if (this.pdfTemplates.length > 0) {
        headers.push({
          text: 'PDF',
          align: 'right',
          sortable: false,
          value: 'pdf_print'
        })
      }
      //console.log('headers', headers)
      return headers
    },

    stateCompletePercentages () {
      let states = {}
      const startingPercentage = 10
      const count = this.$store.getters.objectStatesByModule[this.moduleName] &&
        this.$store.getters.objectStatesByModule[this.moduleName].filter(state => {
          return !state.finalState
        }).length + 1
      if (!count || count === 0) {
        return states
      }
      const oneStepPercentage = (100 - 10) / count
      this.$store.getters.objectStatesByModule[this.moduleName].forEach((state, index) => {
        state.completePercentage = startingPercentage + index * oneStepPercentage
        if (state.finalState) { state.completePercentage = 100 }
        states[state.stateName] = state
      })
      return states
    },

    tableReloadTrigger () {
      console.log(JSON.stringify(this.options))
      return JSON.stringify(this.options)
    },

    itemsPerPage () {
      return this.options.itemsPerPage
    },

    page () {
      return this.options.page
    },

    sortDesc () {
      return this.options.sortDesc
    },

    sortBy () {
      return this.options.sortBy
    },
  },

  watch: {
    showFormNextToList (value) {
      if (value) {
        this.searchClosedMobile = true
      } else {
        this.searchClosedMobile = false
      }
    },

    tableReloadTrigger (value) {
      console.log('trigger change', value)
      this.openList()
    },

    moduleName (value) {
      this.initializeModule()
    }
  },

  created () {
    this.initializeModule()
    if (this.parentId) {
      this.itemsPerPage = 100
    }
    document.addEventListener('mousemove', this.listenMouseMove)
  },

  destroyed () {
    document.removeEventListener('mousemove', this.listenMouseMove)
  },

  methods: {
    ...sharedMethods,

    initializeModule () {
      if (this.level === 0) {
        this.selectedModuleName = this.moduleName
      }
      if (this.moduleName) {
        if (this.mobileBreakpoint) {
          this.searchClosedMobile = true
        }
        if (this.modules[this.moduleName]) {
          this.module = this.modules[this.moduleName]
          this.openList()
          this.loadSelectFilterOptions()
        } else {
          this.module = {}
        }
      }
      this.setModuleViewsDefaults()
    },

    setModuleViewsDefaults () {
      if (this.mobileBreakpoint) { return }
      this.selectedRightModuleView = null
      this.moduleViewsComputed.forEach(moduleView => {
        if (moduleView.openByDefault && moduleView.rightPosition) {
          this.selectedRightModuleView = moduleView
        }
        if (moduleView.openByDefault && moduleView.bottomPosition) {
          this.selectedBottomModuleView = moduleView
        }
        if (moduleView.openByDefault && moduleView.leftPosition) {
          this.selectedLeftModuleView = moduleView
        }
      })
    },

    toggleSearchClose () {
      if (this.mobileBreakpoint) { // this.showFormNextToList
        this.searchClosedMobile = !this.searchClosedMobile
      } else {
        this.searchClosedDesktop = !this.searchClosedDesktop
      }
    },

    selectModuleView (moduleView) {
      console.log('moduleView', moduleView)
      // TODO -change it to name check instead of type
      if (this.selectedRightModuleViewId === moduleView.id && moduleView.rightPosition) {
        this.selectedRightModuleView = null
      } else if (moduleView.rightPosition) {
        this.selectedRightModuleView = null
        this.$nextTick(() => {
          this.selectedRightModuleView = moduleView
        })
      }

      if (this.selectedBottomModuleViewId === moduleView.id && moduleView.bottomPosition) {
        this.selectedBottomModuleView = null
      } else if (moduleView.bottomPosition) {
        this.selectedBottomModuleView = null
        this.$nextTick(() => {
          this.selectedBottomModuleView = moduleView
        })
      }

      if (this.selectedLeftModuleViewId === moduleView.id && moduleView.leftPosition) {
        this.selectedLeftModuleView = null
      } else if (moduleView.leftPosition) {
        this.selectedLeftModuleView = null
        this.$nextTick(() => {
          this.selectedLeftModuleView = moduleView
        })
      }
    },

    labelText (field) {
      return field['fieldNameText_' + this.language] || field.fieldNameText_en || field.fieldName
    },

    noAction () {

    },

    toggleBooleanValue (index, fieldName) {
      this.$store.commit('toggleBooleanValue', {
        moduleName: this.moduleName,
        index: index,
        fieldName: fieldName
      })
      api.toggleBooleanValue(this.apiUrl, this.moduleName, this.items[index]._id, fieldName, this.items[index][fieldName])
    },

    listenMouseMove (e) {
      if (this.draggingId) {
        this.draggedX = e.clientX - this.dragStartX
        this.draggedY = e.clientY - this.dragStartY
        if (e.which === 0) {
          this.stopDrag()
        }
      }
    },

    stopDrag () {
      if (this.draggingId) {
        this.$store.dispatch('sortList', {
          dragId: this.draggingId,
          targetId: this.dragPlaceholderId,
          moduleName: this.moduleName
        })
      }
      this.draggingId = null
      this.draggingIndex = null
    },

    dragPlaceholderStyle (props) {
      return {
        width: this.dragOrigWidth + 'px',
        height: this.dragOrigHeight + 'px',
        border: '3px solid #ddd',
        borderRadius: '6px',
        background: 'white !important'
      }
    },

    changePlaceholderId (item) {
      if (this.draggingId) {
        this.dragPlaceholderId = item._id
      }
    },

    dragRowStyle (props, state) {
      if (this.draggingId === props.item._id) {
        let el = document.getElementById('list-table')
        return {
          position: 'absolute',
          top: (this.draggedY + this.dragElOrigY + this.dragOrigHeight / 2 + 20) + 'px',
          left: (this.draggedX + this.dragElOrigX + 150) + 'px',
          zIndex: 1001,
          width: this.dragOrigWidth + 'px',
          height: this.dragOrigHeight + 'px',
          border: '3px solid #ddd',
          background: 'white',
          borderRadius: '6px'
        }
      } else if (this.draggingId) {
        return {
          background: 'none !important'
        }
      } else if (state) {
        let color = state.color || '#9E9E9E'
        let hex = {
          red: 155,
          green: 155,
          blue: 155
        }
        try {
          hex = hexRgb(color)
        } catch (e) {
          console.log('error', e)
        }
        return {
          backgroundImage: 'linear-gradient( ' +
              '90deg,' +
              // 'rgba(' + hex.red + ',' + hex.green + ',' + hex.blue + ', 0.33),' +
              'rgba(255, 255, 255, 0),' +
              'rgba(255, 255, 255, 0),' +
              'rgba(255, 255, 255, 0),' +
              'rgba(255, 255, 255, 0),' +
              'rgba(' + hex.red + ',' + hex.green + ',' + hex.blue + ', 0.01),' +
              'rgba(' + hex.red + ',' + hex.green + ',' + hex.blue + ', 0.01),' +
              'rgba(' + hex.red + ',' + hex.green + ',' + hex.blue + ', 0.03),' +
              'rgba(' + hex.red + ',' + hex.green + ',' + hex.blue + ', 0.06),' +
              'rgba(' + hex.red + ',' + hex.green + ',' + hex.blue + ', 0.12))',
          backgroundRepeat: 'no-repeat',
          backgroundSize: state.completePercentage + '% 100%'
        }
      }
      return {}
    },

    loadSelectFilterOptions () {
      Object.keys(this.module.fields).forEach(fieldName => {
        let field = this.module.fields[fieldName]
        if (field.filterType === 'Select' || field.filterType === 'SelectSearch') {
          this.$store.dispatch('getFilterOptions', {
            moduleName: field.linkModule,
            textField: field.linkModuleDisplayField,
            searchString: ''
          }).then(options => {
            this.$store.commit('setSelectItems', {
              k: fieldName,
              v: options
            })
            // TODO use language
            if (this.modules && field.linkModule && field.linkModuleDisplayField &&
              this.modules[field.linkModule] &&
              this.modules[field.linkModule].fields &&
              this.modules[field.linkModule].fields[field.linkModuleDisplayField]
            ) {
              this.$store.commit('setSelectItemsDisplayFields', {
                k: fieldName,
                v: field.linkModuleDisplayField +
                (this.modules[field.linkModule].fields[field.linkModuleDisplayField].multilingual
                  ? '_en'
                  : '')
              })
            } else {
              // should not be here... debug
              console.log('________________________________________', fieldName, field)
              console.log('options', options)
              console.log('modules', this.modules)
            }
          })
        }
      })
    },

    openList () {
      this.loading = true
      let filters = []
      if (this.parentId) {
        console.log('parent filter', this.modules[this.parentModule])
        console.log('this-module', this.modules[this.moduleName])
        const useReferenceId = this.modules[this.moduleName].fields && this.modules[this.moduleName].fields.referenceModule && this.modules[this.moduleName].fields.referenceId
        if (useReferenceId) {
          filters.push(
            {
              key: 'referenceId',
              value: this.parentId
            }
          )

        } else {
          filters.push(
            {
              key: this.modules[this.parentModule].singular,
              value: this.parentId
            }
          )
        }
        this.setSubtableFormOpenModule('')
      }
      let requestFields = this.listFields
      if (this.isLanguageField) {
        requestFields.push('language')
      }
      this.$store.dispatch('getListItemsToStore', {
        moduleName: this.moduleName,
        pagination: {
          rowsPerPage: this.itemsPerPage,
          page: this.page,
          sortBy: this.sortBy || 'createdAt',
          descending: this.sortDesc
        },
        listFields: requestFields,
        fields: this.fields,
        filters: filters,
        searchFilters: this.preparedSearchFilters()
      }).then((items) => {
        this.loading = false
      })
    },

    preparedSearchFilters () {
      let filters = {}
      this.fields.forEach(fieldName => {
        console.log('fieldName', fieldName)
        if (this.searchFilters[this.moduleName + '_' + fieldName]) {
          filters[fieldName] = this.searchFilters[this.moduleName + '_' + fieldName]
        }
      })
      // Add state filters manually
      if (this.searchFilters[this.moduleName + '__states']) {
        filters._states = this.searchFilters[this.moduleName + '__states'].join(',')
      }
      return filters
    },

    openEditForm (item) {
      if (this.parentId) {
        this.setSubtableFormOpenModule(this.moduleName)
        this.$parent.subtableSelectedId = item._id
      } else {
        this.$router.push('/' + this.moduleName + '/form/' + item._id)
      }
    },

    openNewForm () {
      if (this.parentId) {
        this.setSubtableFormOpenModule(this.moduleName)
        this.$parent.subtableSelectedId = '0'
      } else {
        this.$router.push('/' + this.moduleName + '/form/0')
      }
    },

    translation (fieldName) {
      if (this.translations &&
        this.translations[this.language] &&
        this.translations[this.language][this.moduleName] &&
        this.translations[this.language][this.moduleName][fieldName]) {
        return this.translations[this.language][this.moduleName][fieldName]
      }
      return fieldName
    },

    showInList (field, fieldName) {
      const canRead = this.readAttributes.includes(fieldName) ||
        (this.readAttributes.includes('*') && !this.readAttributes.includes('!' + fieldName))
      if (!canRead) {
        return false
      }
      let hideSubtableReferenceField = false
      if (this.parentId) {
        let singularParentObjectName = this.modules[this.parentModule].singular
        if (singularParentObjectName === fieldName) {
          hideSubtableReferenceField = true
        }
      }
      return !field.listHide && field.type !== 'Title' && !hideSubtableReferenceField
    }

    // options: {
    //  handler () {
    //    this.openList()
    //  },
    //  deep: true
    // }
  }
}
</script>

<style>
.string-table-column {
  min-width: 150px;
}
.first-text-field {
  font-weight: 700;
  font-size: 16px !important;
}
.th, .td {
  padding: 5px;
  margin: 10px;
}
.list-title {
  font-weight: 300;
  font-size: 20px !important;
}
.list-title-dense {
  font-weight: 500;
}
@media only screen and (max-width: 599px) {
  .v-data-table td, .v-data-table th {
    padding: 0 6px !important;
  }
}

</style>
